<template>
    <div v-if="lawnTreatment && featureFlags.flags.new_ltrs_flow_signup" class="grid__col-md-6">
        <div class="grid ls-margin--bottom new-lawntreatment-section">
            <div
                class="grid ls-border-bottom-radius-none ls-margin--top ls-margin--bottom"
                testid="new-lawntreatment-section"
            >
                <div class="grid__col-md-12">
                    <p class="ls-bold new-lawntreatment-section-heading" data-font-size="-1">
                        Add Lawn Treatment
                    </p>
                    <span data-font-size="-2">
                        Our pros will customize a comprehensive fertilization &#38; weed control
                        service for your lawn needs.
                        <a
                            v-ls-track.click="{
                                target: 'new-learn-more-about-lawn-treatment--link',
                            }"
                            class="ls-color--blue ls-nowrap"
                            testid="new-lawntreatment-learn-more"
                            @click.prevent="openModal('whyLawnTreatment')"
                        >
                            Learn More
                        </a>
                    </span>
                    <div class="new-flow-ltrs-service__button-row">
                        <label
                            v-ls-track.click="{
                                target: 'new-flow-ltrs-service-drawer--toggle',
                            }"
                            for="new-flow-ltrs-service"
                            :class="{ 'ls-button--block': screenSize.xs }"
                            @click.prevent="toggleNewLawnTreatmentFlow()"
                        >
                            <input
                                id="new-flow-ltrs-service"
                                type="checkbox"
                                :checked="lawnTreatmentIsInCart"
                            />
                            <branded-checkbox
                                :is-active="lawnTreatmentIsInCart"
                                :is-big-icon="true"
                            />
                            <span class="ls-bold add-lawn-treatment-package" data-font-size="-1">
                                Add Lawn Treatment Package
                                <br />
                                <span class="secondary-text ls-normal" data-font-size="-1">
                                    ${{ lawnTreatment.price.price }} / service
                                </span>
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable camelcase */
import { mapState, mapGetters, mapActions } from 'vuex';
import * as types from '@/store/types';
import brandedCheckbox from '@/components/original-mydot/branded-checkbox/BrandedCheckbox.vue';

export default {
    components: {
        brandedCheckbox,
    },
    computed: {
        ...mapState(['cart', 'featureFlags', 'screenSize']),
        ...mapGetters({
            lawnTreatment: types.ORDER__GET_PRICED_LAWNTREATMENT,
            lawnTreatmentIsInCart: types.CART__GET_PRICED_LAWNTREATMENT_IS_IN_CART,
        }),
    },
    methods: {
        ...mapActions({
            addServiceToCart: types.CART__ADD_SERVICE_TO_CART,
            openModal: types.MODAL__OPEN_MODAL,
            removeServiceFromCart: types.CART__REMOVE_SERVICE_FROM_CART,
        }),
        toggleNewLawnTreatmentFlow() {
            /* eslint-disable no-unused-expressions */
            this.lawnTreatmentIsInCart
                ? this.removeServiceFromCart(this.lawnTreatment)
                : this.addServiceToCart(this.lawnTreatment);
        },
    },
};
</script>

<style lang="scss">
.new-lawntreatment-section {
    margin-left: 10px;
    margin-top: 20px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 4px 12px;
    margin-bottom: -10px;
}

.new-lawntreatment-section-heading {
    color: $theme-color-primary;
}

.new-flow-ltrs-service__button-row {
    margin-top: rem(5);
    margin-bottom: rem(-9);

    label {
        display: flex;
        user-select: none;
        cursor: pointer;

        input {
            display: none;
        }
    }
}

.add-lawn-treatment-package {
    margin-left: 5px;
}
</style>
